module.exports = __webpack_public_path__ + "static/media/linkOn.415d42ef.svg";